import React from "react";
import { StyledContainer } from "./styles";


export interface ContainerProps {
  id?: string;
  border?: boolean;
  marginTop?:any;
  marginBottom?:any;
  backgroundColor?:string;
  padding?:string;
  children?: React.ReactNode;

}

const Container = ({ id,border,marginTop,marginBottom,backgroundColor,padding, children }: ContainerProps) => (
  <StyledContainer id={id} border={border} marginTop={marginTop} marginBottom={marginBottom} backgroundColor={backgroundColor} padding={padding}>{children}</StyledContainer>
);

export default Container;
